<template>
  <div>
    <v-file-input
      :rules="rules"
      dense
      accept="image/png, image/jpeg, image/bmp"
      placeholder="Upload Ảnh Đại Diện"
      prepend-icon="mdi-presentation"
      label="Ảnh Đại Diện"
      @change="onAvatarChange"
    ></v-file-input>
    <v-text-field
      v-model="videoLink"
      class="pt-4"
      prepend-icon="mdi-presentation"
      placeholder="Điền link nhúng (Embed code)"
      label="Link nhúng video đầu trang sản phẩm"
      dense
    ></v-text-field>
    <v-checkbox
      v-model="enableShowcase"
      label="Cho phép hiển thị ở trang sản phẩm học viên"
    ></v-checkbox>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { get } from 'lodash'
export default {
  props: {
    major: Object,
  },
  data: () => ({
    rules: [
      (value) =>
        !value ||
        value.size < 2000000 ||
        'Ảnh đại diện cần có dung lượng nhỏ hơn 2 MB!',
    ],
    url: '/default-avatar.png',
    enableShowcase: false,
    videoLink: '',
  }),
  created() {
    this.reset()
  },
  methods: {
    ...mapActions('major', ['uploadAvatar', 'destroyAvatar']),
    onAvatarChange(file) {
      if (file) {
        this.saveAvatar(file)
      }
    },
    saveAvatar(image) {
      if (this.major.avatar) {
        this.destroyAvatar(this.major.avatar.id)
      }
      let formData = new FormData()
      formData.append('files', image)
      formData.append('refId', this.major.id)
      formData.append('ref', 'major')
      formData.append('field', 'avatar')
      this.uploadAvatar({ formData, majorId: this.major.id })
    },
    getData() {
      let query = {
        enableShowcase: this.enableShowcase,
      }
      if (this.videoLink && this.videoLink !== '')
        query.videoLink = this.videoLink
      return query
    },
    reset() {
      this.videoLink = get(this.major, 'metadata.videoLink', '')
      this.enableShowcase = get(this.major, 'metadata.enableShowcase', false)
    },
  },
  watch: {
    major(major) {
      this.reset()
    },
  },
}
</script>

<style scoped>
</style>
